import _ from 'underscore';
import Backbone from 'backbone';
import tplMoney from './excess-money-template.hbs';
import tplMoneySudda from './excess-money-template-sudda.hbs';
import tplPchip from './excess-pchip-template.hbs';
import { eventBus } from '../../state-manager/event-bus';

export var ExcessView = Backbone.View.extend({
  tagName: 'div',

  template: {
    money: tplMoney,
    moneySudda: tplMoneySudda,
    pchip: tplPchip
  },

  events: {
    'click [data-excess-click=openMallClass]': 'openMallClass',
    'click [data-excess-click=confirm]': 'confirm'
  },

  render: function (option) {
    var context = this.model.toJSON();
    var rendered = this.template[option](context);
    this.$el.html(rendered);
    return this;
  },

  confirm: function (e) {
    e.preventDefault();
    this.remove();
  },

  openMallClass: function (e) {
    e.preventDefault();
    eventBus.trigger('open:mall', { to: 'pokerclass' });
    this.remove();
  }
});
